// extracted by mini-css-extract-plugin
export var byline = "styles-module--byline--50a26";
export var content = "styles-module--content--ad246";
export var contentImage = "styles-module--contentImage--76b46";
export var contentTable = "styles-module--contentTable--ec936";
export var heading = "styles-module--heading--c1485";
export var image = "styles-module--image--39ced";
export var post = "styles-module--post--1f9d5";
export var title = "styles-module--title--59661";